import { useLanguage } from '../context/LanguageContext';
import { Calendar, ArrowRight } from 'lucide-react';

const BookCallBanner = ({ onBookCall }) => {
  const { t, language } = useLanguage();

  return (
    <section 
      className="py-16 md:py-20"
      style={{ backgroundColor: 'var(--sage-600)' }}
      data-testid="book-call-banner"
    >
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        {/* Icon */}
        <div 
          className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6"
          style={{ backgroundColor: 'rgba(255,255,255,0.15)' }}
        >
          <Calendar size={28} className="text-white" />
        </div>

        {/* Title */}
        <h2 
          className="text-3xl md:text-4xl text-white mb-4"
          style={{ fontFamily: 'Cormorant Garamond, serif' }}
        >
          {t('book_title')}
        </h2>

        {/* Subtitle */}
        <p className="text-white/80 text-lg mb-8 max-w-xl mx-auto">
          {t('book_subtitle')}
        </p>

        {/* CTA Button */}
        <button
          onClick={onBookCall}
          className="inline-flex items-center gap-2 px-8 py-4 bg-white text-sage-700 rounded-full font-medium text-lg transition-all hover:shadow-xl hover:transform hover:-translate-y-1"
          style={{ color: 'var(--sage-700)' }}
          data-testid="book-call-cta"
        >
          <Calendar size={20} />
          {t('book_cta')}
          <ArrowRight size={18} className={language === 'he' ? 'rotate-180' : ''} />
        </button>

        {/* Note */}
        <p className="text-white/60 text-sm mt-6">
          {language === 'he' ? 'שעה • שיחת היכרות חינמית' : '1 hour • Free intro call'}
        </p>
      </div>
    </section>
  );
};

export default BookCallBanner;
